/*
 * Copyright (c) 2020 Staffino, s.r.o. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Martin Komara, April 2020
 */

import React from 'react';
import { FlowBlockRoot } from '@staffino/model';
import FlowStateManager from './flow-state-manager';

type FlowContextType = {
  stateManager: FlowStateManager;
  definition: FlowBlockRoot;
  handleSubmit?: (values: Record<string, any>) => void;
};

const FlowContext = React.createContext<FlowContextType>(undefined);
export default FlowContext;
